import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Organizers List")
], -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "symbol symbol-45px me-5" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "text-dark" }
const _hoisted_15 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_16 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "svg-icon svg-icon-3" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'auctions'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.can('create', 'auctions'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('organizers-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewOrganizer')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-titleEn": _withCtx(({ row: organizer }) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    alt: "Pic",
                    src: organizer.logo
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "text-dark fw-bolder text-hover-primary mb-1 fs-6",
                    onClick: _withModifiers(($event: any) => (_ctx.editOrganizer(organizer.id)), ["prevent"])
                  }, _toDisplayString(organizer.titleEn), 9, _hoisted_12),
                  _createElementVNode("a", {
                    href: `tel:${organizer.phone}`,
                    class: "text-muted text-hover-primary fw-bold text-muted d-block fs-7"
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate('phone')), 1),
                    _createTextVNode(": " + _toDisplayString(organizer.phone), 1)
                  ], 8, _hoisted_13)
                ])
              ])
            ]),
            "cell-titleAr": _withCtx(({ row: organizer }) => [
              _createTextVNode(_toDisplayString(organizer.titleAr), 1)
            ]),
            "cell-is_active": _withCtx(({ row: organizer }) => [
              (organizer.is_active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-actions": _withCtx(({ row: organizer }) => [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                onClick: _withModifiers(($event: any) => (_ctx.editOrganizer(organizer.id)), ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_18, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                ])
              ], 8, _hoisted_17),
              (_ctx.can('remove', 'auctions'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleStatusOrganizer(organizer)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_20, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ], 8, _hoisted_19))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}